import React, { useEffect, useState } from 'react';
import './OrderTechnician.css';

const OrderTechnician = ({ bcuCode }) => {
  const [technicians, setTechnicians] = useState([]);
  const [formData, setFormData] = useState({
    id: '',
    password: '',
    name: '',
    bcu_code: '',
    useYn: 'Y',  // useYn 기본값 설정
  });
  
  const [editFormData, setEditFormData] = useState({
    id: '',
    password: '',
    name: '',
    useYn: 'Y',
  });
  const [error, setError] = useState('');
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);  // 수정 팝업 상태 관리
  const [editError, setEditError] = useState('');  // 수정 에러 메시지 상태

  const serverUrl =
    window.location.hostname === "localhost" ||
    window.location.hostname === "192.168.0.254"
      ? `http://${window.location.hostname}:4000`
      : `${window.location.protocol}//smes.izenimplant.com`;

  useEffect(() => {
    // bcuCode가 변경될 때마다 기공사 목록을 다시 조회
    fetchTechnicians();
  }, [bcuCode]);

  // 기공사 목록을 조회하는 함수
  const fetchTechnicians = async () => {
    let url = `${serverUrl}/api/technicians`;
    url += `?userId=${encodeURIComponent(bcuCode)}`;

    try {
      const res = await fetch(url);
      const data = await res.json();

      const techniciansData = data.map((tech) => {
        return {
          id: tech.BCE_CODE,
          name: tech.BCE_NAME,
          useYn: tech.BCE_USEYN,  // 사용여부 추가
        };
      });

      setTechnicians(techniciansData); // 최신 기공사 목록을 상태에 저장
    } catch (err) {
      console.error(err);
      setError('데이터를 불러오는 중 오류 발생');
    }
  };

  // 폼 입력 값 처리
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // 기공사 등록
  const handleSubmit = (e) => {
    e.preventDefault();    

    if (!formData.id || !formData.password || !formData.name) {
      alert('아이디, 비밀번호, 기공사명은 필수입니다.');
      return;
    }
    setError('');

    const isConfirmed = window.confirm('등록하시겠습니까?');
    if (!isConfirmed) return;

    fetch(`${serverUrl}/api/technicians`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        ...formData,
        bcu_code: bcuCode,
      }),
    })
      .then((res) => {
        if (!res.ok) {
          return res.json().then((data) => {
            throw new Error(data.error || '등록 실패');
          });
        }
        return res.json();
      })
      .then(() => {
        // 기공사 목록을 재조회
        fetchTechnicians();  // 기공사 목록을 다시 가져옴
        setFormData({ id: '', password: '', name: '', bcu_code: '', useYn: 'Y' });
        setError('');
      })
      .catch((err) => {
        console.error('Error:', err);
        setError(err.message);
      });
  };

  // 기공사 삭제
  const handleDelete = (id) => {
    const isConfirmed = window.confirm(`삭제하시겠습니까?\n기공사코드 : ${id}`);
    if (!isConfirmed) return;

    fetch(`${serverUrl}/api/technicians/${id}?userId=${encodeURIComponent(bcuCode)}`, {
      method: 'DELETE',
    })
      .then((res) => {
        if (!res.ok) {
          return res.json().then((data) => {
            throw new Error(data.error || '삭제 실패');
          });
        }
        setTechnicians((prev) => prev.filter((tech) => tech.id !== id));
        return res.json();
      })
      .then(() => {
        // 성공적으로 삭제된 경우
      })
      .catch((err) => {
        setError(err.message);  // 서버에서 전달된 에러 메시지 표시
      });
  };

  // 기공사 수정
  const handleEdit = (tech) => {
    setEditFormData({
      id: tech.id,
      name: tech.name,
      password: '',
      useYn: tech.useYn || 'Y',
    });
    setIsEditModalOpen(true);  // 수정 팝업 열기
  };

  // 수정 폼 입력 처리
  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // 수정 저장
  const handleSaveEdit = () => {
    if (!editFormData.name || (editFormData.password !== '' && !editFormData.password)) {
      setEditError('기공사명과 비밀번호는 필수입니다.');
      return;
    }

    const isConfirmed = window.confirm('저장하시겠습니까?');
    if (!isConfirmed) return;

    fetch(`${serverUrl}/api/technicians/update`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        ...editFormData,
        bcu_code: bcuCode,
      }),
    })
      .then((res) => {
        if (!res.ok) {
          return res.json().then((data) => {
            throw new Error(data.error || '수정 실패');
          });
        }
        return res.json();
      })
      .then(() => {
        fetchTechnicians();  // 기공사 목록을 다시 가져옴
        setIsEditModalOpen(false);  // 팝업 닫기
        setEditError('');  // 오류 메시지 초기화
      })
      .catch((err) => {
        console.error('Error:', err);
        setEditError(err.message);  // 수정 팝업 오류 메시지
      });
  };

  return (
    <div className="order-technician-container">
      <div className="technician-header">
        <h2>기공사 관리</h2>
      </div>
      <div className="technician-form-section">
        <div className="technician-header">
          <h3>기공사 등록</h3>
          <button onClick={handleSubmit} className="submit-button">
            등록
          </button>
        </div>
        <form onSubmit={(e) => e.preventDefault()} className="technician-form">
          <div className="form-row">
            <label htmlFor="id">아이디</label>
            <input
              type="text"
              name="id"
              id="id"
              value={formData.id}
              onChange={handleChange}
              placeholder="아이디 입력"
            />
          </div>
          <div className="form-row">
            <label htmlFor="password">비밀번호</label>
            <input
              type="password"
              name="password"
              id="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="비밀번호 입력"
            />
          </div>
          <div className="form-row">
            <label htmlFor="name">기공사명</label>
            <input
              type="text"
              name="name"
              id="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="기공사명 입력"
            />
          </div>
          {error && <div className="error-message">{error}</div>}
        </form>
      </div>

      <div className="technician-list-section">
        <h3>기공사 목록</h3>
        <table className="technician-table">
          <thead>
            <tr>
              <th>기공사코드</th>
              <th>기공사명</th>
              <th>사용여부</th>
              <th>수정</th>
              <th>삭제</th>
            </tr>
          </thead>
          <tbody>
          {technicians.map((tech, index) => (
            <tr key={index}>
              <td>{tech.id}</td>
              <td>{tech.name}</td>
              <td>
                {tech.useYn === 'Y' ? '사용' : '미사용'}
              </td>
              <td style={{ textAlign: 'center' }}>
                <button
                  className="update-button"
                  onClick={() => handleEdit(tech)}
                >
                  수정
                </button>
              </td>
              <td style={{ textAlign: 'center' }}>
                <button
                  onClick={() => handleDelete(tech.id)}
                  className="delete-button"
                >
                  삭제
                </button>
              </td>
            </tr>
          ))}
        </tbody>
        </table>
      </div>

      {/* 수정 팝업 */}
      {isEditModalOpen && (
        <div className="edit-modal">
          <div className="modal-content">
            <div className="modal-header">
              <h4>기공사 수정</h4>
              <div className="modal-buttons">
                <button onClick={handleSaveEdit} className="tech-save-button">
                  저장
                </button>
                <button
                  onClick={() => {
                    setIsEditModalOpen(false);  // 팝업 닫기
                    setEditError('');  // 오류 메시지 초기화
                  }}
                  className="close-button"
                >
                  닫기
                </button>
              </div>
            </div>
            <div className="modal-body">
              <div className="form-row">
                <label htmlFor="edit-code">기공사코드</label>
                <input
                  type="text"
                  name="code"
                  id="edit-code"
                  value={editFormData.id}  // 기공사코드 (tech.id)
                  readOnly  // 수정 불가
                />
              </div>
              <div className="form-row">
                <label htmlFor="edit-name">기공사명</label>
                <input
                  type="text"
                  name="name"
                  id="edit-name"
                  value={editFormData.name}
                  onChange={handleEditChange}
                />
              </div>
              <div className="form-row">
                <label htmlFor="edit-password">비밀번호</label>
                <input
                  type="password"
                  name="password"
                  id="edit-password"
                  value={editFormData.password}
                  onChange={handleEditChange}
                />
              </div>
              <div className="form-row">
                <label htmlFor="useYn">사용여부</label>
                <select
                  name="useYn"
                  id="useYn"
                  value={editFormData.useYn}  // useYn을 editFormData에서 가져옴
                  onChange={handleEditChange}
                >
                  <option value="Y">사용</option>
                  <option value="N">미사용</option>
                </select>
              </div>
              {editError && <div className="error-message">{editError}</div>}
            </div>
            <div className="modal-footer">
              {/* 이곳은 필요없음 */}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default OrderTechnician;
